<template>
  <app-panel
    title="Basic Info"
    class="container"
    v-on:next="next"
    v-bind:showNext="true"
    v-on:prev="prev"
    v-bind:showBack="true"
  >
    <div class="row">
      <!-- First Name -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-first"
        label="First Name:"
        label-for="input-first"
      >
        <b-form-input
          id="input-first"
          v-model="form.firstName"
          type="text"
          required
          placeholder="Enter First Name"
        ></b-form-input>
      </b-form-group>
      <!-- Last Name -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-last"
        label="Last Name:"
        label-for="input-last"
      >
        <b-input-group>
          <b-form-input
            id="input-last"
            v-model="form.lastName"
            required
            placeholder="Enter Last Name"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <!-- Phone -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-phone"
        label="Cell Phone Number:"
        label-for="input-last"
        description="You will recieve sms messages confirming your transactions"
      >
        <b-input-group>
          <b-form-input
            id="input-phone"
            v-model="form.phone"
            v-mask="'1-(###)-###-####'"
            required
            placeholder="Enter Phone Number"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
    </div>
    <div class="row">
      <!-- Social -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-social"
        label="Social Security Number:"
        label-for="input-social"
      >
        <b-input-group>
          <b-form-input
            id="input-social"
            v-model="form.social"
            v-mask="'###-##-####'"
            required
            :type="showSocial ? undefined : 'password'"
            placeholder="Enter Social"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              v-on:click="showSocial = !showSocial"
              variant="info"
              class="show-btn"
              >{{ showSocial ? "Hide" : "show" }}</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-email"
        label="Email:"
        label-for="input-social"
      >
        <b-input-group>
          <b-form-input
            id="input-email"
            v-model="form.email"
            required
            type="email"
            placeholder="Enter Email"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
      <!-- DOB -->
      <b-form-group
        class="col-lg-4 col-md-6"
        id="input-group-dob"
        label="Date of Birth:"
        label-for="input-dob"
        description="You must be 18 or older to apply"
      >
        <b-input-group>
          <Datepicker
            :disabled-dates="disabledDates"
            input-class="selectable-input form-control"
            placeholder="MM/DD/YYYY"
            format="MM/dd/yyyy"
            id="input-dob"
            v-mask="'##/##/####'"
            v-bind:typeable="new Boolean(true)"
            v-model="form.dob"
          />
        </b-input-group>
      </b-form-group>
    </div>
    <b-alert show variant="danger" v-for="error in errors" v-bind:key="error">{{
      error
    }}</b-alert>
  </app-panel>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import appPanel from "./appPanel.vue";
function eighteenYearsAgo() {
  let d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  return d;
}
export default {
  components: {
    Datepicker,
    appPanel,
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        phone: "",
        dob: "",
        email: "",
        social: "",
      },
      showSocial: false,
      disabledDates: {
        from: eighteenYearsAgo(),
      },
      errors: [],
    };
  },
  methods: {
    validate() {
      this.errors = [];
      if (this.form.firstName.length <= 0)
        this.errors.push("First Name Required");
      if (this.form.lastName.length <= 0)
        this.errors.push("Last Name Required");
      if (!this.validPhone(this.form.phone))
        this.errors.push("Valid Phone Number Required");
      if (!this.validSocial(this.form.social))
        this.errors.push("Valid Social Required");
      if (!this.validEmail(this.form.email))
        this.errors.push("Valid Email Required");
      if (!this.form.dob) this.errors.push("Date of Birth Required");
      if (this.errors.length > 3) this.errors = this.errors.slice(0, 3);
      if (!this.errors.length) return true;
    },
    validSocial(social) {
      var re = /^\d{3}-\d{2}-\d{4}$/;
      return re.test(social);
    },
    validPhone(phone) {
      var re = /^1-\(\d{3}\)-\d{3}-\d{4}$/;
      return re.test(phone);
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    next() {
      if (this.validate())
        this.$emit("next", {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          phone: this.form.phone.replace(/[(|)|-]/gi, "").substr(1),
          dateOfBirth: this.form.dob,
          email1: this.form.email,
          social: this.form.social.replace(/-/g, ""),
        });
    },
    prev() {
      this.$emit("prev");
    },
  },
  mounted() {
    let dob_in = document.querySelector("#input-dob");
    dob_in.onkeypress = (e) => {
      if (e.keyCode == 8) return true;
      if (
        e.key === "/" &&
        (dob_in.value.length === 1 ||
          dob_in.value.length === 3 ||
          dob_in.value.length === 4)
      )
        return false;
      let re = /^\d{1,2}\/?(\d{1,2})?\/?(\d{1,4})?$/g;
      return re.test(dob_in.value + e.key);
    };
    dob_in.onkeydown = function(event) {
      var key = event.keyCode || event.charCode;
      if (key == 8) return true;
      if (key == 46) return false;
      var strokes = dob_in.value.length;

      if (strokes === 2 || strokes === 5) {
        let thisVal = dob_in.value;
        thisVal += "/";
        dob_in.value = thisVal;
      }
      // if someone deletes the first slash and then types a number this handles it
      if (strokes >= 3 && strokes < 5) {
        let thisVal = dob_in.value;
        if (thisVal.charAt(2) != "/") {
          var txt1 = thisVal.slice(0, 2) + "/" + thisVal.slice(2);
          dob_in.value = txt1;
        }
      }
      // if someone deletes the second slash and then types a number this handles it
      if (strokes >= 6) {
        let thisVal = dob_in.value;
        if (thisVal.charAt(5) != "/") {
          var txt2 = thisVal.slice(0, 5) + "/" + thisVal.slice(5);
          dob_in.value = txt2;
        }
      }
    };
  },
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.selectable-input {
  background-color: white !important;
}
.input-group-sep {
}
.alert {
  margin-top: 5px;
}
.selectable-input {
  background-color: white !important;
}
.input-group-sep {
  margin-right: -1px;
  margin-left: -1px;
}
.input-group-sep > .input-group-text {
  border-radius: 0;
}
.show-btn {
  background-color: #db9c94 !important;
}
</style>
